<template>
  <div class="plan">
    <condition />
    <course :editable=editable />
    <plan-price />
    <control />
  </div>
</template>

<script>
import Condition from '../components/organisms/Condition'
import Course from '../components/organisms/Course'
import Control from '../components/organisms/Control'
import PlanPrice from '../components/organisms/PlanPrice'
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo')

export default {
  components: {
    Condition,
    Course,
    Control,
    PlanPrice
  },
  created () {
    if (!this.$route.params.fromMap) {
      this.$store.dispatch('loading/beginLoading')
      this.$store.dispatch('condition/resetDetailOptions')
      this.$store.dispatch('destinations/resetEditable')
      this.$store.dispatch('favorites/fetchAll')
      this.$store.dispatch('flight/fetchAll')
        .then(() => {
          this.$store.dispatch('places/fetchAll')
            .then(() => {
              if (this.poiId) {
                const place = this.$store.getters['places/getPlace'](this.poiId)
                const profile = this.$store.getters['user/getProfile']
                const places = this.$store.getters['places/getPlaces']
                var stayPlace
                if (profile.stayPlace === "その他エリア(マップから検索して追加)") {
                  stayPlace = Object.assign({}, profile.otherPlace, {genreIds: ["stay"]})
                } else {
                  stayPlace = places.find(place => place.name === profile.stayPlace)
                }
                var coursePlaces = []
                let fromFlights = this.$store.getters['flight/getFlight'](profile.depDate)
                const depFlight = fromFlights.timetable.find(flight => flight.number === profile.depFlightNumber)
                let toFlights = this.$store.getters['flight/getFlight'](profile.arrDate)
                const arrFlight = toFlights.timetable.find(flight => flight.number === profile.arrFlightNumber)
                coursePlaces.push(Object.assign({}, places.find(place => place.name === depFlight.fromName), { lock: false, changeVisit: false, disableAddPlace: true }))
                coursePlaces.push(Object.assign({}, places.find(place => place.name === depFlight.toName), { lock: true, changeVisit: false, baseStartTime: depFlight.arrival }))
                coursePlaces.push(Object.assign({}, place, { lock: false, changeVisit: true }))
                //滞在時間を設定
                const defaultCheckIn = "20:00"
                const defaultCheckOut = 720
                const fromDate = moment(profile.depDate)
                const toDate = moment(profile.arrDate)
                for (let i = 0; i < toDate.diff(fromDate,'days')-1; i++) {
                  const t = moment(profile.depDate + ' ' + defaultCheckIn).add(i, 'days')
                  coursePlaces.push(Object.assign({}, stayPlace, { lock: true, changeVisit: true, checkIn: t, visit: defaultCheckOut }))
                }
                coursePlaces.push(Object.assign({}, places.find(place => place.name === arrFlight.fromName), { lock: true, changeVisit: false, disableAddPlace: true }))
                coursePlaces.push(Object.assign({}, places.find(place => place.name === arrFlight.toName), { lock: true, changeVisit: false, disableAddPlace: true }))
                this.$store.dispatch('destinations/buildDestinations', coursePlaces)
                this.$store.dispatch('plans/updateTitle', place.name + this.$t('course_label'))
                this.$store.dispatch('routes/search')
              }
            })
            .finally(() => {
              this.$store.dispatch('loading/endLoading')
            })
          if (this.courseId) {
            this.$store.dispatch('loading/beginLoading')
            this.$store.dispatch('courses/fetchAll')
              .then(() => {
                const modelCourse = this.$store.getters['courses/getCourse'](this.courseId)
                const profile = this.$store.getters['user/getProfile']
                const places = this.$store.getters['places/getPlaces']
                var stayPlace
                if (profile.stayPlace === "その他エリア(マップから検索して追加)") {
                  stayPlace = Object.assign({}, profile.otherPlace, {genreIds: ["stay"]})
                } else {
                  stayPlace = places.find(place => place.name === profile.stayPlace)
                }
                var coursePlaces = []
                let fromFlights = this.$store.getters['flight/getFlight'](profile.depDate)
                const depFlight = fromFlights.timetable.find(flight => flight.number === profile.depFlightNumber)
                let toFlights = this.$store.getters['flight/getFlight'](profile.arrDate)
                const arrFlight = toFlights.timetable.find(flight => flight.number === profile.arrFlightNumber)
                coursePlaces.push(Object.assign({}, places.find(place => place.name === depFlight.fromName), { lock: false, changeVisit: false, disableAddPlace: true }))
                coursePlaces.push(Object.assign({}, places.find(place => place.name === depFlight.toName), { lock: true, changeVisit: false, baseStartTime: depFlight.arrival }))
                //滞在時間を設定
                const defaultCheckIn = "20:00"
                const defaultCheckOut = 720
                const fromDate = moment(profile.depDate)
                const toDate = moment(profile.arrDate)
                for (let i = 0; i < toDate.diff(fromDate,'days')-1; i++) {
                  const t = moment(profile.depDate + ' ' + defaultCheckIn).add(i, 'days')
                  coursePlaces.push(Object.assign({}, stayPlace, { lock: true, changeVisit: true, checkIn: t, visit: defaultCheckOut }))
                  //モデルコースは2日目に設定する
                  if (i === 0){
                    for (let j = 0; j < modelCourse.places.length; j++) {
                      coursePlaces.push(Object.assign({}, modelCourse.places[j], { lock: false, changeVisit: true, genreIds: ["other"]}))
                    }
                  }
                }
                coursePlaces.push(Object.assign({}, places.find(place => place.name === arrFlight.fromName), { lock: true, changeVisit: false, disableAddPlace: true }))
                coursePlaces.push(Object.assign({}, places.find(place => place.name === arrFlight.toName), { lock: true, changeVisit: false, disableAddPlace: true }))
                this.$store.dispatch('destinations/buildDestinations', coursePlaces)
                this.$store.dispatch('plans/updateTitle', modelCourse.title)
                this.$store.dispatch('routes/search')
              })
              .finally(() => {
                this.$store.dispatch('loading/endLoading')
              })
          }
        })
    }
  },
  props: {
    courseId: {
      type: Number
    },
    poiId: {
      type: Number
    }
  },
  data () {
    return {
      editable: true
    }
  }
}
</script>
